<template>
  <form @submit.prevent="userLocalization">
    <div class="uk-card uk-card-small uk-card-default">
      <div class="uk-card-header">
        <div class="uk-card-title">
          {{local_page_keys.title_edit_localization}}
        </div>
      </div>
      <div class="uk-card-body">
        <div>
          <div class="uk-grid uk-grid-small uk-child-width-1-1" data-uk-grid>
            <label v-for="(item, index) in local_selected_keys.languages" :key="index">
              <input
                  class="uk-radio"
                  type="radio"
                  name="radio2"
                  v-model="selectedLanguages"
                  :value="item"
                  :disabled="isHidden(item)">
              {{ item }}
              <span v-if="isHidden(item)" class="uk-label tm-label">{{local_page_keys.in_developing}}</span>
            </label>
          </div>
        </div>
      </div>
      <div class="uk-card-footer uk-text-right">
        <button type="submit" class="uk-button tm-button-success">
          {{local_page_keys.button_update_localization}}
          <span v-if="loading" class="uk-icon uk-spinner uk-margin-left" data-uk-spinner></span>
        </button>
      </div>
    </div>
  </form>
</template>

<script>
  import formMixin from "@/mixins/form-mixin";

  export default {
    name: "user-localization-card",
    props: {
      user: Object
    },
    mixins: [formMixin],
    data: () => ({
      selectedLanguages: null,
      local_page_keys: {},
      local_selected_keys: {},
      loading: false,
      visibleLanguageForAdmins: ['Russian'],
      visibleLanguageForAny: ['Russian', 'Ukrainian']
    }),
    methods: {
      async getLanguages() {
        await this.$store.dispatch('localization/getLanguages');
        this.local_selected_keys = await this.$store.getters['localization/getLanguages'];
        this.selectedLanguages = this.local_selected_keys.selected;
        this.$emit('setUserLang', this.local_selected_keys.selected_short_name);
      },
      async userLocalization() {
        let param = {
          language: this.selectedLanguages
        }
        this.loading = true;
        await this.$store.dispatch('localization/updateLanguages', param);
        let newLang = await this.$store.getters['localization/updateLanguages'];
        if (newLang.status == 200) {
          //this.$router.go();
          await this.getLanguages();
          await this.getTranslates();
          //UIkit.notification({message: this.local_page_keys.profile_saved, pos: 'top-center', status: 'success', timeout: 1500})
          await this.$store.dispatch("alerts/success", this.local_page_keys.profile_saved);
          this.loading = false;

        } else {
          await this.$store.dispatch(
              "alerts/error",
              this.local_selected_keys.alert_something_wrong
          );
          this.loading = false;
        }
      },
      isHidden(language) {
        if (this.user.role === 'admin' || this.user.role === 'pro-retoucher' || this.user.role === 'senior-retoucher') {
          return !this.visibleLanguageForAdmins.includes(language)
        } else {
          return !this.visibleLanguageForAny.includes(language)
        }
      },
      async getTranslates() {
        this.local_page_keys = await this.$filtergetLocalisationPage('user-localization');
        //await this.$store.dispatch("localization/dashBoardLocal");
      }
    },
    async mounted() {
      await this.getLanguages();
      await this.getTranslates();
    }
  };
</script>
